(() => {
  const estimatedDeliveryPattern = /^Geschatte levertijd(?:\s+is)?\b.*$/i;

  const normalizeText = (value) => value.replace(/\s+/g, ' ').trim();

  const removeEstimatedDeliveryBlock = (textNode) => {
    let target = textNode.parentElement;
    if (!target) return;

    while (target.parentElement && target.parentElement !== document.body) {
      const parentText = normalizeText(target.parentElement.textContent || '');
      if (parentText.length > 120 || !estimatedDeliveryPattern.test(parentText)) break;
      target = target.parentElement;
    }

    target.remove();
  };

  const scanForEstimatedDelivery = (root) => {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const matches = [];
    let textNode = walker.nextNode();

    while (textNode) {
      const text = normalizeText(textNode.nodeValue || '');
      if (text.length <= 120 && estimatedDeliveryPattern.test(text)) matches.push(textNode);
      textNode = walker.nextNode();
    }

    matches.forEach(removeEstimatedDeliveryBlock);
  };

  const removeExistingBlocks = () => scanForEstimatedDelivery(document.body);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeExistingBlocks, { once: true });
  } else {
    removeExistingBlocks();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) scanForEstimatedDelivery(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
